import { call, put, takeLatest } from 'redux-saga/effects'
import { select } from '@redux-saga/core/effects'
import { getServiceIdSelector } from '../../user/selectors'
import { getPcrIdSelector } from '../../home/selectors'
import { throwPcrException } from '../../pcr/store/pcr.actions'
import { SignaturesConstants } from '../store/signatures.constants'
import { setAttachmentsList, showAttachments } from '../store/signatures.actions'
import { PcrDocsService } from '../../../services/pcrDocs.service'
import { IPcr } from '../../pcr/store/pcr.types'
import {
  setCameraAttachmentsList,
  setDisableCameraButton,
} from '../../cameraAttachments/store/cameraAttachments.actions'
import { getMaximumCameraAttachments } from '../../cameraAttachments/store/cameraAttachments.reducer'
import { performWithMutexHOG } from '../../../services/mutexUtility.service'

export function* getAllAttachments() {
  const pcrId: string = yield select(getPcrIdSelector)

  if (!pcrId) {
    return
  }
  try {
    const serviceId: string = yield select(getServiceIdSelector)
    const pcrDocsService = new PcrDocsService(serviceId)
    const pcrDoc: IPcr = yield call([pcrDocsService, pcrDocsService.getPCR], pcrId)

    if (pcrDoc._attachments) {
      const list = Object.entries(pcrDoc._attachments).map(([k, v]: any) => {
        return {
          key: k,
          imageSrc: 'data:' + v.fileExtension + ';base64,' + v.data,
        }
      })
      yield put(setAttachmentsList(list))
    } else {
      yield put(setAttachmentsList([]))
    }

    if (pcrDoc._fileAttachments) {
      if (pcrDoc._fileAttachments.length < getMaximumCameraAttachments()) {
        yield put(setDisableCameraButton(false))
      }
      yield put(setCameraAttachmentsList(pcrDoc._fileAttachments))
    } else {
      yield put(setDisableCameraButton(false))
    }

    yield put(showAttachments(true))
  } catch (e) {
    yield put(throwPcrException(`getAllAttachments() error: ${e}`))
  }
}

export function* getAllAttachmentsSaga() {
  yield takeLatest([SignaturesConstants.GET_ATTACHMENTS], performWithMutexHOG, getAllAttachments)
}
